import { render, staticRenderFns } from "./navigation-button.vue?vue&type=template&id=1805ce50&scoped=true"
import script from "./navigation-button.vue?vue&type=script&lang=js"
export * from "./navigation-button.vue?vue&type=script&lang=js"
import style0 from "./navigation-button.vue?vue&type=style&index=0&id=1805ce50&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1805ce50",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/components/button/africa/navigation-button.vue
// module id = Zror
// module chunks = 37